import { HiOutlineLockClosed } from "react-icons/hi2";
import { useSelector } from "react-redux";

const SubscribeAccessCard = ({
  title = "Subscription required",
  description = "This content is included with an active membership. Subscribe to unlock full access.",
  onSubscribeNow,
  compact = false,
  className = "",
}) => {
  const { theme } = useSelector((state) => state.theme);
  const isDark = theme === "dark";

  return (
    <div
      className={`pointer-events-auto w-full max-w-md rounded-2xl border px-5 py-5 text-center shadow-2xl sm:px-6 sm:py-6 ${
        compact ? "max-w-sm px-4 py-4" : ""
      } ${
        isDark
          ? "border-slate-600/30 bg-[#2f3349]/95 text-slate-100"
          : "border-slate-200/80 bg-white/95 text-slate-900"
      } ${className}`}
    >
      <div
        className={`mx-auto mb-3 flex items-center justify-center rounded-full ${
          compact ? "mb-2 h-11 w-11" : "mb-4 h-14 w-14"
        } ${isDark ? "bg-indigo-500/20 text-indigo-300" : "bg-indigo-50 text-indigo-600"}`}
      >
        <HiOutlineLockClosed size={compact ? 22 : 28} />
      </div>

      <h3 className={`font-bold ${compact ? "text-base" : "text-lg"} ${isDark ? "text-white" : "text-gray-900"}`}>
        {title}
      </h3>
      <p
        className={`mt-2 leading-relaxed ${compact ? "text-xs" : "text-sm"} ${
          isDark ? "text-slate-400" : "text-gray-600"
        }`}
      >
        {description}
      </p>

      <button
        type="button"
        onClick={onSubscribeNow}
        className={`mt-4 inline-flex w-full items-center justify-center gap-2 rounded-xl bg-indigo-600 font-semibold text-white shadow-lg shadow-indigo-500/25 transition hover:bg-indigo-700 ${
          compact ? "mt-3 px-4 py-2.5 text-sm" : "px-5 py-3 text-sm"
        }`}
      >
        Subscribe now
      </button>
    </div>
  );
};

export default SubscribeAccessCard;
